import Flickity from 'flickity'

/**
 * This acts as a replacement for default `Flickity.Player` adding
 * functionallity regarding videos to the autoplay option
 */
class Player extends Flickity.Player {

  constructor(parent) {
    super(parent)

    this.onVideoEnded = this.videoEnded.bind(this)
  }

  get videoElement() {
		// check if current slide contains a video
		const currentSlide = this.parent.selectedElement
		return currentSlide.querySelector('video')
  }

  videoSetup() {
    const video = this.videoElement

    // check for loop attribute and remove it so the 'ended' event will be
    // fired after the video has played once
    if (video.hasAttribute('loop')) {
      video.setAttribute('data-loop', '')
      video.loop = false
    }

    // if the video already ended, go to next slide
    if (video.ended) {
      this.videoEnded()
    }

    // else play the video and wait for it to end
    else {
      video.play()
      video.addEventListener('ended', this.onVideoEnded, { once: true })
    }
  }

  videoEnded() {
    this.parent.next(true)
    this.clear()
    this.play()
  }

  tick() {
    // do not tick if not playing
    if (this.state != 'playing') {
      return
    }

    const video = this.videoElement
    if (video) {
      this.stop()
      video.currentTime = 0

      this.videoSetup()
    }

    else {
      super.tick()
    }
  };

  pause() {
    super.pause()

    const video = this.videoElement
    if (video) {
      video.removeEventListener('ended', this.onVideoEnded)

      if (video.hasAttribute('data-loop')) {
        video.removeAttribute('data-loop')
        video.loop = true
      }
    }
  };

  unpause() {
    super.unpause()

    const video = this.videoElement
    if (video) {
      this.videoSetup()
    }
  };
}

// -------------------------- Flickity -------------------------- //

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) return;

  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// -----  ----- //

Flickity.Player = Player

export default Flickity
